import { CircleAlert, CircleCheck, Info, type LucideIcon, TriangleAlert } from 'lucide-react';

export type Tone = 'error' | 'warning' | 'success' | 'info';

/**
 * Icon and colours for each tone, shared by inline notices and toasts.
 * `mark` colours the icon, `card` tints a notice.
 */
export const TONES = {
  error: {
    icon: CircleAlert,
    mark: 'text-destructive',
    card: 'border-destructive/25 bg-destructive/[0.08]',
  },
  warning: {
    icon: TriangleAlert,
    mark: 'text-desktop-warning',
    card: 'border-desktop-warning/25 bg-desktop-warning/[0.08]',
  },
  success: {
    icon: CircleCheck,
    mark: 'text-desktop-success',
    card: 'border-desktop-success/25 bg-desktop-success/[0.08]',
  },
  info: {
    icon: Info,
    mark: 'text-muted-foreground',
    card: 'border-hairline bg-surface-panel',
  },
} as const satisfies Record<Tone, { icon: LucideIcon; mark: string; card: string }>;
